import pdfLink from "../../../../src/images/nmc-code-of-conduct-1-0.pdf";
import * as React from 'react';
export default {
  pdfLink,
  React
};